import React, { Fragment, useState, useEffect } from 'react'
import { Table } from 'react-bootstrap'
import { gql, useLazyQuery, useQuery } from '@apollo/client'
import Card from '../common/Card'
import Progress from '../common/Progress'
import { CubeLoader } from '../../layouts/components/CubeLoader'
import _ from 'lodash'

const GET_CATEGORIES = gql`
    query Categories($where: CategoryWhere) {
        categories(where: $where) {
            name
            audience
            ratio
        }
    }
`

const GET_CAMPAIGN = gql`
    query Campaigns {
        campaigns {
            categories
        }
    }
`

const ClassificationReport = () => {
    const [getCategories, categories] = useLazyQuery(GET_CATEGORIES)
    const campaign = useQuery(GET_CAMPAIGN, {
        onCompleted: () => {
            const campaignCategories = campaign.data.campaigns[0].categories
                ? JSON.parse(campaign.data.campaigns[0].categories)
                : []
            const aliases = _.map(campaignCategories, (category) => category.toLowerCase())
            getCategories({
                variables: { where: { alias_IN: aliases } },
            })
        },
    })

    const [data, setData] = useState(null)

    // Show categories sorted by ratio and if ratio > 10
    useEffect(() => {
        if (categories?.data?.categories && !categories.loading) {
            const array = _.map(categories.data.categories, (category) => {
                return {
                    name: category.name,
                    audience: category.audience,
                    ratio: category.ratio,
                    softcolor: category.ratio < 50 ? 'primary' : 'success',
                    color: category.ratio < 50 ? 'primary' : 'success',
                    value: category.ratio,
                }
            }).sort((a, b) => b.audience - a.audience)

            setData(array)
        }
    }, [categories])

    return (
        <Card className="table-responsive border-0" data-aos="fade-up" data-aos-delay="600">
            {categories.loading || !data ? (
                <CubeLoader size="sm" fullScreen={false} />
            ) : (
                <Fragment>
                    <Card.Header className="card-header p-4">
                        <h6 className="card-title">Generative AI Classification by Sub Audiences</h6>
                    </Card.Header>
                    <Card.Body className="card-body p-0">
                        <Table striped responsive className="mb-0" style={{ marginTop: '28px' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}></th>
                                    <th className="small">
                                        <b>Sub Audiences</b>
                                    </th>
                                    <th className="small">
                                        <b>Audience</b>
                                    </th>
                                    <th className="small">
                                        <b>Ratio</b>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{ width: '50px' }}>
                                                <div className="d-flex align-items-center">
                                                    <small className="mb-0">{index + 1}</small>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <small>{item.name}</small>
                                                </div>
                                            </td>
                                            <td>
                                                <small>{item.audience}</small>
                                            </td>
                                            <td>
                                                <div className="mb-2 d-flex align-items-center">
                                                    <small>{item.ratio}%</small>
                                                </div>
                                                <Progress
                                                    softcolors={item.softcolor}
                                                    color={item.color}
                                                    className="shadow-none w-100"
                                                    value={item.value}
                                                    minvalue={0}
                                                    maxvalue={100}
                                                    style={{ height: '4px' }}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Fragment>
            )}
        </Card>
    )
}

export default ClassificationReport
